import { TechnicalError } from '@algoan/deep-dive/technical-error';
import { signIn } from './auth-utils';

export const AuthError: React.FC = () => {
  return <TechnicalError onButtonClick={() => signIn({ callbackUrl: '/' })} />;
};
